import { useLocation } from 'react-router-dom'
import useAuth from './useAuth'
import { checkPageAccess, getPageInfoByPathName } from 'utils/helpers'
import { useMemo } from 'react'

const usePageAccess = () => {
  const { user } = useAuth()
  const { pathname } = useLocation()

  const page = useMemo(() => getPageInfoByPathName(pathname), [pathname])

  const accessDetails = useMemo(
    () => checkPageAccess(page?.id, user?.pageAccess),
    [page?.id, user?.pageAccess],
  )

  return { ...accessDetails }
}

export default usePageAccess
